import React, { useEffect, useState, useCallback } from "react";
import awardStyles from "../styles/AwardsAndAchievements.module.css";

const EventCarousel = ({ images = [] }) => {
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const total = images.length;

  const nextSlide = useCallback(() => {
    setCurrent((prev) => (prev + 1) % total);
  }, [total]);

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(nextSlide, 3500);
    return () => clearInterval(interval);
  }, [nextSlide, isPaused]);

  // 👉 Background logic (IMPORTANT)
  const getBackground = (img) => {
    if (img.type === "logo") return "#ffffff";
    if (img.type === "dark") return "#0f172a";
    return "linear-gradient(135deg, #f1f5f9, #e2e8f0)";
  };

  return (
    <div
      className={awardStyles["event-carousel"]}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className={awardStyles["carousel-container"]}>
        {images.map((img, index) => (
          <div
            key={index}
            className={`${awardStyles["carousel-slide"]} ${
              index === current ? awardStyles["active"] : ""
            }`}
            style={{ background: getBackground(img) }}
          >
            <img src={img.src} alt="event" />
          </div>
        ))}
      </div>

      {/* Dots */}
      <div className={awardStyles["carousel-dots"]}>
        {images.map((_, i) => (
          <span
            key={i}
            className={`${awardStyles["dot"]} ${
              i === current ? awardStyles["active"] : ""
            }`}
            onClick={() => setCurrent(i)}
          />
        ))}
      </div>
    </div>
  );
};

export default EventCarousel;
